import { jsx as _jsx } from "react/jsx-runtime";
import { CoinsIcon, HandHoldingDollarIcon, HouseBuildingIcon, HouseMoneyIcon, } from "@gemini/icons";
import { InvestmentValueType } from "./type";
export const InvestmentValueMapIcon = {
    [InvestmentValueType.isForInvestment]: _jsx(HouseMoneyIcon, {}),
    [InvestmentValueType.isRented]: _jsx(HouseBuildingIcon, {}),
    [InvestmentValueType.rentalIncome]: _jsx(CoinsIcon, {}),
    [InvestmentValueType.expectedRentalIncome]: _jsx(CoinsIcon, {}),
    [InvestmentValueType.yieldFactor]: _jsx(HandHoldingDollarIcon, {}),
};
